<template>
  <mdb-btn
    :size="size"
    :title="title"
    :disabled="disabled"
    :gradient="gradient"
    :icon="icon"
    class="bridge8-button"
    @click.native="$emit('click')"
  />
</template>

<script>
import {mdbIcon, mdbBtn} from 'mdbvue'

export default {
  name: 'Bridge8Button',
  props: {
    danger: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  },
  computed: {
    gradient: {
      get () {
        return this.danger ? 'sunny-morning' : 'aqua'
      }
    }
  },
  components: {
    mdbIcon,
    mdbBtn
  }
}
</script>

<style lang="sass" scoped>
.bridge8-button
  margin: 0.2em
  border-radius: 10em!important
</style>



// WEBPACK FOOTER //
// src/components/Bridge8Button.vue